import { Validators } from '@angular/forms';
import { FormSchema } from './form-schema';

export const FORGOT_PASSWORD_FORM_DEFAULT_SCHEMA: FormSchema = {
  username: {
    type: 'text',
    validators: [Validators.required],
    label: 'Username',
    icon: 'person'
  }
};
